{
  "perm": {
    "products__read": "商品を見る",
    "products__write": "商品を追加・変更",
    "products__publish": "商品をサイトに公開・非公開",
    "catalog__read": "カードカタログを見る",
    "catalog__write": "カードカタログ・カテゴリ・ブランドを変更",
    "collections__read": "コレクションを見る",
    "collections__write": "コレクションを変更",
    "import__run": "ファイルから商品を取り込む",
    "media__write": "画像を追加",
    "media__delete": "画像を削除",
    "inventory__read": "在庫を見る",
    "inventory__receive": "入荷する",
    "inventory__adjust": "在庫を修正（理由が必要）",
    "inventory__transfer": "店舗間で在庫を移動",
    "inventory__count": "棚卸しをする",
    "inventory__count__approve": "大きな棚卸し差異を承認",
    "inventory__holds__release": "取り置きを解除",
    "inventory__holds__manage": "手動で取り置き",
    "inventory__conflicts__resolve": "二重販売を解決",
    "inventory__live_show__manage": "ライブ配信販売を管理",
    "listings__publish": "マーケットに出品（今後）",
    "channels__manage": "マーケットと連携（今後）",
    "orders__read": "注文を見る",
    "orders__update": "注文のメモ・タグ・メール",
    "orders__fulfill": "注文を準備・発送",
    "orders__cancel": "注文をキャンセル",
    "orders__refund": "注文を返金",
    "orders__edit": "注文の住所・商品を変更",
    "discounts__write": "割引コードを作成",
    "payments__read": "支払いを見る",
    "payments__confirm": "入金確認",
    "payments__refund": "返金を承認・ストアクレジット発行",
    "payments__reconcile": "カード端末の明細を照合",
    "payments__settings": "決済方法・手数料を変更",
    "pos__sell": "レジで販売",
    "pos__refund": "レジで返金",
    "pos__void": "レジの取消",
    "pos__returns": "レジで返品受付",
    "pos__open_drawer": "ドロワーを開ける",
    "pos__discount_over_10": "10%を超える値引き",
    "pos__override_price": "レジで価格を変更",
    "pos__shift__manage": "シフトの開始・締め",
    "pos__devices__pair": "レジを登録",
    "pos__hold": "会計を保留",
    "pos__manual_line": "登録外の商品を販売",
    "pos__pay_out": "ドロワーから出金",
    "pos__shift_close_variance": "差額ありでシフトを締める",
    "pos__reports": "レジのレポートを見る",
    "buylist__accept": "お客様から買取",
    "buylist__accept_over_limit": "上限を超える買取",
    "consignment__read": "委託者・委託品を見る",
    "consignment__manage": "委託と精算を管理",
    "consignment__intake": "委託受付",
    "consignment__price_override": "委託者の大幅値下げを承認",
    "payouts__create": "委託者に支払う",
    "payouts__export_bank": "振込ファイルをダウンロード",
    "kyc__verify": "本人確認をする",
    "kyc__view": "本人確認書類の番号を全部見る",
    "kobutsu__read": "古物台帳を見る",
    "kobutsu__export": "古物台帳をダウンロード",
    "customers__read": "お客様を見る",
    "customers__write": "お客様情報を変更",
    "customers__merge": "お客様を統合",
    "customers__export": "お客様一覧をダウンロード",
    "tax__read": "税のレポートを見る",
    "tax__taxfree": "免税販売（研修が必要）",
    "tax__settings": "税の設定を変更",
    "cms__edit": "サイトのページ・デザインを編集",
    "cms__publish": "サイトの変更を公開",
    "settings__write": "店の設定を変更",
    "settings__read": "店の設定を見る",
    "staff__read": "スタッフを見る",
    "staff__manage": "スタッフを追加・変更",
    "staff__roles": "役割を変更",
    "api_keys__manage": "他のアプリ用のキー",
    "reports__view": "レポート・原価を見る",
    "reports__consignment": "委託のレポートを見る",
    "audit__view": "変更履歴を見る",
    "audit__export": "変更履歴をダウンロード",
    "inbox__read": "やることを見る・対応する",
    "inbox__manage": "やることを割り当てる",
    "notifications__read": "送信メールを見る"
  },
  "area": {
    "products": "商品",
    "catalog": "カードカタログ",
    "collections": "コレクション",
    "import": "取り込み",
    "media": "画像",
    "inventory": "在庫",
    "listings": "マーケット",
    "channels": "マーケット",
    "orders": "注文",
    "discounts": "割引",
    "payments": "支払い",
    "pos": "レジ",
    "buylist": "買取",
    "consignment": "委託",
    "payouts": "委託者への支払い",
    "kyc": "本人確認",
    "kobutsu": "古物台帳",
    "customers": "お客様",
    "tax": "税",
    "cms": "サイト",
    "settings": "設定",
    "staff": "スタッフ",
    "api_keys": "他のアプリ",
    "reports": "レポート",
    "audit": "履歴",
    "inbox": "やること",
    "notifications": "メール"
  },
  "list": {
    "title": "スタッフ",
    "intro": "管理画面やレジにサインインする全員です。このページを変更できるのはオーナーだけです。",
    "add": "スタッフを追加",
    "error": "スタッフ一覧を読み込めませんでした。",
    "empty": "スタッフはまだいません。",
    "you": "（自分）",
    "active": "有効",
    "off": "無効",
    "locked": "パスワード間違いでロック中",
    "role": "役割",
    "shops": "店舗",
    "two_step": "2段階認証",
    "pin": "レジのPIN",
    "last_login": "最終サインイン",
    "on": "オン",
    "set": "設定済み",
    "not_set": "未設定",
    "never": "なし",
    "all_shops": "すべての店舗",
    "a_shop": "店舗",
    "change": "変更",
    "deactivate": "無効にする",
    "reactivate": "有効に戻す",
    "deactivated": "{{name}}はサインインできなくなりました。",
    "reactivated": "{{name}}は再びサインインできます。",
    "reset_two_step": "2段階認証をリセット",
    "reset_pin": "レジのPINをリセット",
    "invited": "招待済み",
    "not_signed_in_yet": "まだログインしていません",
    "invite_valid": "招待リンクの期限：",
    "resend_invite": "招待を再送",
    "invite_resent": "{{email}} に新しい招待メールを送りました。以前のリンクは使えません。"
  },
  "form": {
    "add_title": "スタッフを追加",
    "add_intro": "仮のパスワードが発行され、最初のサインインで本人が自分のパスワードを決めます。",
    "edit_title": "{{name}}を変更",
    "email": "メールアドレス",
    "name": "名前",
    "role": "役割",
    "own_role": "自分の役割は変更できません。",
    "locale": "管理画面の言語",
    "shops": "担当できる店舗",
    "shops_hint": "何も選ばない = すべての店舗。",
    "save": "保存",
    "add": "追加",
    "saved": "スタッフを保存しました。",
    "fill_all": "名前、正しいメールアドレス、役割を入力してください。",
    "created_title": "{{name}}を追加しました",
    "created_body": "この仮パスワードを本人（{{email}}）に渡してください。最初のサインインで自分のパスワードを決めます。",
    "created_once": "表示されるのは今だけです。なくした場合は「変更」から新しいパスワードを発行してください。",
    "created_done": "パスワードを渡しました",
    "add_intro_invite": "本人にパスワード設定用のリンクをメールで送ります。",
    "delivery": "ログインの始め方",
    "delivery_email": "招待メールを送る（おすすめ）",
    "delivery_email_hint": "本人の言語で、自分のパスワードを決めるリンクが届きます。1回だけ使えます。",
    "delivery_temporary_password": "代わりにここで仮パスワードを表示する",
    "delivery_temporary_password_hint": "今メールを見られない人向け — あなたがパスワードを渡します。",
    "invite_done": "閉じる",
    "invite_sent": "{{email}} に招待メールを送りました。本人がリンクから自分のパスワードを決めます。",
    "invite_valid": "リンクは1回だけ、次の日時まで使えます：",
    "invite_two_step": "パスワードの後、スマートフォンのアプリで2段階認証を設定します。",
    "invite_resend_hint": "なくした・期限切れの場合は、スタッフ一覧の「招待を再送」を使ってください。"
  },
  "two_step": {
    "title": "{{name}}の2段階認証をリセットしますか？",
    "body": "認証アプリが使えなくなり、次のサインインで設定し直します。",
    "confirm": "2段階認証をリセット",
    "done": "{{name}}の2段階認証をリセットしました。"
  },
  "locale": {
    "ja": "日本語",
    "th": "ไทย",
    "en": "English",
    "zh-Hant": "繁體中文",
    "zh-Hans": "简体中文"
  },
  "roles": {
    "title": "役割とできること",
    "intro": "列が役割、行ができることです。店の6つの役割は固定です — コピーして自分の役割を作れます。",
    "fixed_hint": "固定の役割 — 変えるにはコピーしてください。",
    "fixed": "固定の役割",
    "error": "役割を読み込めませんでした。",
    "permission": "できること",
    "people_other": "{{count}}人",
    "copy": "「{{role}}」をコピー",
    "copy_name": "{{role}}（コピー）",
    "copy_title": "「{{role}}」から新しい役割",
    "copy_intro": "新しい役割は同じチェックから始まります。スタッフに分かる名前を付けてください。",
    "copy_submit": "役割を作る",
    "copied": "新しい役割を作りました。",
    "new_name": "新しい役割の名前",
    "delete": "削除",
    "delete_title": "役割「{{role}}」を削除しますか？",
    "delete_body": "この役割の人はいません。削除します。",
    "delete_in_use_other": "まだ{{count}}人がこの役割です — 先に別の役割にしてください。",
    "deleted": "役割を削除しました。",
    "cell": "{{role}}: {{permission}}",
    "confirm_add": "「{{role}}」に「{{permission}}」を許可しますか？",
    "confirm_remove": "「{{role}}」の「{{permission}}」をやめますか？",
    "affects_other": "{{count}}人に影響します。サインイン中の人には{{minutes}}分以内に反映されます — すぐに反映するには、一度サインアウトしてサインインし直してもらってください。",
    "confirm": "役割を変更",
    "changed": "役割を変更しました。",
    "system": {
      "owner": "オーナー",
      "manager": "マネージャー",
      "staff": "店舗スタッフ",
      "cashier": "レジ担当",
      "content_editor": "サイト編集者",
      "consignment_manager": "委託担当"
    },
    "editable_hint": "ショップの役割はここで変更できます。オーナーの役割も変更できます。「初期設定に戻す」で最初の設定に戻ります。鍵のマークは、お店がログインできなくならないよう、オーナーの役割に常に残る項目です。",
    "always_kept": "お店がログインできなくならないよう、オーナーの役割には常に残ります。",
    "customized": "ショップで変更済み",
    "reset": "初期設定に戻す：「{{role}}」",
    "reset_title": "「{{role}}」を最初の設定に戻しますか？",
    "reset_body": "チェックが、お店を始めたときの状態に戻ります。",
    "reset_confirm": "初期設定に戻す",
    "reset_done": "役割を最初の設定に戻しました。"
  },
  "keys": {
    "title": "他のアプリとの連携",
    "intro": "キーを使うと、別のプログラムが店のデータを使えます。プログラムごとに、必要なことだけのキーを作ってください。",
    "add": "キーを作る",
    "error": "キーを読み込めませんでした。",
    "empty": "キーはまだありません",
    "empty_body": "プログラムから求められたときだけ作ってください。",
    "show_revoked": "停止したキーも表示",
    "state_on": "有効",
    "state_paused": "一時停止（作成者が無効）",
    "state_revoked": "停止",
    "created_at": "作成",
    "last_used": "最終利用",
    "never": "なし",
    "expires": "有効期限",
    "revoke": "このキーを停止",
    "revoke_title": "キー「{{name}}」を停止しますか？",
    "revoke_body": "使っているプログラムは1分以内に動かなくなります。元に戻せません — 必要なら新しいキーを作ってください。",
    "revoked": "キー「{{name}}」を停止しました。",
    "add_title": "キーを作る",
    "add_intro": "使うプログラムの名前を付けてください。",
    "name": "名前",
    "expires_optional": "有効期限（任意）",
    "may": "プログラムができること",
    "create": "キーを作る",
    "fill_all": "名前を入れ、1つ以上チェックしてください。",
    "created_title": "キー「{{name}}」を作りました — 今コピーしてください",
    "created_once": "表示されるのはこの1回だけです。閉じると最初の数文字だけが表示されます。",
    "created_done": "コピーしました"
  }
}
